import { render, staticRenderFns } from "./EditBlacklistItem.vue?vue&type=template&id=47f209ce&scoped=true&"
import script from "./EditBlacklistItem.vue?vue&type=script&lang=js&"
export * from "./EditBlacklistItem.vue?vue&type=script&lang=js&"
import style0 from "./EditBlacklistItem.vue?vue&type=style&index=0&id=47f209ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f209ce",
  null
  
)

export default component.exports